import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClockRotateLeft,
  faHourglassHalf,
  faDatabase,
  faListUl,
  faChartSimple,
} from "@fortawesome/free-solid-svg-icons";

/**
 * Journey results tab content - temporary waiting state
 *
 * This component shows a "waiting for data" screen for the Journey Results tab,
 * indicating that statistics are still being collected and will be available soon.
 */
export const JourneyResultsContent = () => {
  return (
    <div className="py-10 px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center h-[70vh]">
      <div className="text-center max-w-lg mx-auto">
        <div className="mb-5 flex justify-center">
          <div className="h-16 w-16 rounded-full bg-brand/10 flex items-center justify-center">
            <FontAwesomeIcon
              icon={faHourglassHalf}
              className="h-8 w-8 text-brand animate-pulse"
              aria-hidden="true"
            />
          </div>
        </div>

        <h2 className="text-2xl font-medium text-gray-800 mb-6">
          Waiting for journey metrics ...
        </h2>
        <p className="text-sm text-gray-600 mb-8">
          Engagement statistics will be available once participants interact
          with the journey touchpoints.
        </p>

        {/* Simple indicators */}
        <div className="grid grid-cols-2 gap-4 mb-6">
          {[
            { icon: faListUl, label: "Participant Count" },
            { icon: faChartSimple, label: "Engagement Rate" },
            { icon: faClockRotateLeft, label: "Time Spent" },
            { icon: faDatabase, label: "Game Interactions" },
          ].map((item, index) => (
            <div key={index} className="flex items-center">
              <FontAwesomeIcon
                icon={item.icon}
                className="h-4 w-4 text-gray-500 mr-2"
              />
              <span className="text-sm text-gray-600">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
